import { t } from 'i18next';
import { ObjectSchema } from 'yup';
import { PhoneCountryCodeType } from '@bus/models';
import { TradingDetailsServicePlanBusinessFormModel_MX } from './formModel';
import { CorrespondenceMethodEnum, NoYesEnum } from '../../../types/forms';
import Yup, {
  maxMobileNumberLength,
  minMobileNumberLength,
  regExEmail,
  regexVat,
} from '../../../services/common/validation';
import { getEnumValues } from '../../../services/common/miscUtils';

export const createTradingDetailsServicePlanBusinessFormValidator = (
  isCroRequired = true
): ObjectSchema<TradingDetailsServicePlanBusinessFormModel_MX> => {
  const croNumberMaxLength = 6;
  const croRequiredSchema = Yup.string().requiredWithMsg().onlyNumbers().lengthBetween(0, croNumberMaxLength);

  const croOptionalSchema = Yup.string().optional().onlyNumbers().lengthBetween(0, croNumberMaxLength);

  const croNumber = isCroRequired ? croRequiredSchema : croOptionalSchema;
  return Yup.object({
    tradingAs: Yup.string().requiredWithMsg(),
    legalName: Yup.string().requiredWithMsg(),
    vatLiable: Yup.string().requiredWithMsg().oneOf(getEnumValues(NoYesEnum)),
    vatNumber: Yup.string().when('vatLiable', {
      is: (vatLiable: NoYesEnum) => vatLiable === NoYesEnum.yes,
      then: (schema) =>
        schema
          .matches(regexVat, { message: t('validation:invalidVat') })
          .lengthBetween(0, 10)
          .requiredWithMsg(),
      otherwise: (schema) =>
        schema
          .optional()
          .matches(regexVat, { message: t('validation:invalidVat') })
          .lengthBetween(0, 10),
    }),
    croNumber,
    email: Yup.string().required(t('validation:required')).matches(regExEmail, t('validation:invalidEmail')),
    mobileNumber: Yup.string().requiredWithMsg().lengthBetween(minMobileNumberLength, maxMobileNumberLength),
    countryCode: Yup.string().requiredWithMsg().oneOf(getEnumValues(PhoneCountryCodeType)),
    correspondenceMethod: Yup.string()
      .required(t('validation:required'))
      .oneOf(getEnumValues(CorrespondenceMethodEnum)),
  });
};
